import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mc-checkbox',
  templateUrl: 'checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckBoxComponent),
      multi: true,
    },
  ],
})

export class CheckBoxComponent implements ControlValueAccessor {
  @Input() labelAttivo = 'Attivo';
  @Input() labelDisattivo = 'Non Attivo';

  /**
   * Holds the current value of the slider
   */
  @Input() checked = false;

  @Input() disabled = false;

  @Output() checkedChanged = new EventEmitter<boolean>();

  constructor() {}

  /**
   * Invoked when the model has been changed
   */
  onChange: (_: any) => void = (_: any) => {};

  /**
   * Invoked when the model has been touched
   */
  onTouched: () => void = () => {};

  /**
   * Method that is invoked on an update of a model.
   */
  updateChanges(): void {
    if (this.disabled) {
      return;
    }
    this.onChange(this.checked);
    this.checkedChanged.emit(this.checked);
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }
  /**
   * Registers a callback function that should be called when the control's value changes in the UI.
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  /**
   * Registers a callback function that should be called when the control receives a blur event.
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onToggleChange(): void {
    if (this.disabled) {
      return;
    }
    this.checked = !this.checked;
    this.updateChanges();

  }
}
